import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

import CriteriumHead from '@hydra/common/criterium/CriteriumHead';
import { usePdfTemplateContext } from '@hydra/common/context/pdfTemplate';
import { useFeatureFlags } from '@hydra/common/components/FeatureFlags/featureFlagContext';
import { CriteriumInterface } from '@hydra/types/review';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    color: theme.palette.secondary.darker,
    flexDirection: 'column',
    [theme.breakpoints.up('pdfPortrait')]: {
      flexDirection: 'row'
    },
    [theme.breakpoints.print()]: {
      pageBreakInside: 'avoid'
    }
  },
  flexDirectionColumn: {
    flexDirection: 'column'
  },
  criteriumTitle: {
    minWidth: 180,
    maxWidth: 250,
    width: '100%',
    paddingRight: theme.spacing(0.25),
    [theme.breakpoints.up('pdfPortrait')]: {
      width: '30%'
    }
  },
  criteriumContent: {
    wordBreak: 'break-word',
    width: '100%',
    '& p:last-child': {
      marginBottom: 0
    }
  },
  criteriumClassic: {
    fontSize: theme.typography.fontSizeMedium
  },
  criteriumModern: {
    fontSize: theme.typography.fontSizeBase
  },
  center: {
    textAlign: 'center'
  }
}));

interface CriteriumContentProps {
  criterium: CriteriumInterface
  children: React.ReactNode
  align?: string
  iconsFillColor: string
}

export const CriteriumContent = ({ criterium, children, align, iconsFillColor }: CriteriumContentProps) => {
  const classes = useStyles();
  const { pdfTheme } = usePdfTemplateContext();
  const featureFlags = useFeatureFlags();
  const newLookReview = featureFlags && featureFlags.newLookReview;

  const contentClass = pdfTheme === 'modern'
    ? classes.criteriumModern
    : classes.criteriumClassic;
  return (
    <div className={classnames(classes.root, newLookReview && classes.flexDirectionColumn)}>
      <div className={classes.criteriumTitle}>
        <CriteriumHead criterium={criterium} iconsFillColor={iconsFillColor} />
      </div>
      <div
        className={classnames(
          classes.criteriumContent,
          contentClass,
          align === 'center' && classes.center
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default CriteriumContent;
